import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse, OtherLeadCaptureInfo} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class OtherLeadCaptureInfoService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'OtherLeadCaptureInfo/';
  // fetch all OtherLeadCaptureInfo in the database
  allData(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getOtherLeadCaptureInfo(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getOtherLeadCaptureInfoByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postOtherLeadCaptureInfo(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteOtherLeadCaptureInfo(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateOtherLeadCaptureInfo(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
  fetchByDivisionId(id): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
}
